export function parseEntityId(value: unknown): number | null {
  const parsed =
    typeof value === 'number'
      ? value
      : typeof value === 'string' && value.trim() !== ''
        ? Number(value)
        : NaN;

  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}
